import React from 'react';
import styles from './_PageContainer.module.css';
import { setupSWLayout as layout } from '@maxis/client-logic/utils/serviceWorkerRegistration';
import useFetch from '@maxis/client-logic/hooks/useFetch';
import { useState, useRef, useEffect } from 'react';
import { getCommonCodeById } from '@maxis/client-logic/utils/commonCodeUtil';
import { useBoundStore } from '@maxis/client-logic/store/useBoundStore';
import PropTypes from 'prop-types';
import { HOME_MENU_ID } from '@maxis/client-logic/constants/constMenuId';
import HelpPopup from '@/pages/System/Popup/HelpPopup';
import { shallow } from 'zustand/shallow';
import { useNavigate } from 'react-router-dom';
import { setLocalStorageItem } from '@maxis/client-logic/utils/localStorageUtil';
import useTabMenu from '@maxis/client-logic/hooks/useTabMenu';
import { LOCAL_STORAGE_KEYS } from '@maxis/client-logic/constants/enumerates';

const PageContainer = ({ children, menuName, menuId, helpYn, menuNameListId, menuNameList }) => {
    const navigate = useNavigate();

    const { favoriteMenu, setFavoriteMenu, setSelectedMenu } = useBoundStore((state) => state.menu);
    const { selectedMenu, menuList } = useBoundStore((state) => state.menu, shallow);
    const stateAll = useBoundStore((state) => state);
    const [showMenuId, setShowMenuId] = useState(false);
    const [newMenuName, setNewMenuName] = useState(menuName);
    const { request } = useFetch();
    const refPopup = useRef();
    const { changeTab } = useTabMenu();

    const [menuPath, setMenuPath] = useState([]);

    useEffect(() => {
        if (HOME_MENU_ID !== menuId) {
            const splitMenuList = menuNameListId.split('>').map((x) => x.trim());
            const _menuPath = splitMenuList?.map?.((menu) => {
                return menuList?.find((item) => item.menuId === menu);
            });

            setMenuPath(_menuPath);
        }
    }, [menuNameList]);

    useEffect(() => {
        const checkSysOpt = async () => {
            const code = await getCommonCodeById('SYSTEM_OPTION', 'SYS_OPT_SHOW_MENU_ID');
            if (code?.propStr1 === 'Y') {
                setShowMenuId(true);
            }
        };
        checkSysOpt();
    }, []);

    const getFavoriteMenuState = (menuId) => {
        const menuList = favoriteMenu?.reduce((pre, cur) => {
            pre.push(cur.menuId ?? cur.MENU_ID);
            return pre;
        }, []);
        return menuList?.includes(menuId);
    };

    const onSetFavorite = async (menuId) => {
        const param = { MENU_ID: menuId };
        const response = await request(null, {
            ...param,
            serviceId: 'FavoriteMenuService',
            process: [{ saveFavorite: '즐겨찾는 메뉴 등록' }],
            isSystem: true,
        });
        if (response) {
            const camelResponse = response?.data?.result?.map((x) => {
                return {
                    isActive: x.IS_ACTIVE,
                    menuId: x.MENU_ID,
                    menuName: x.MENU_NM,
                    programPath: x.PGM_PATH,
                    programRoutePath: x.ROUTING_PATH,
                };
            });
            setFavoriteMenu(camelResponse);
        }
    };

    const openPopup = () => {
        refPopup.current.showPopup(menuId);
    };
    const v = layout();

    const homeButtonHandle = () => {
        // 그리드 개인화 기능을 위한 메뉴ID 인식
        setLocalStorageItem(LOCAL_STORAGE_KEYS.MENU_ID, HOME_MENU_ID);

        setSelectedMenu({
            menuId: HOME_MENU_ID,
            menuName: 'home',
            sideYn: 'Y',
            displayYn: 'Y',
            menuNameList: 'home',
        });

        changeTab(HOME_MENU_ID);
    };

    const movePage = (item) => {
        if (item?.programRoutePath)
            navigate(import.meta.env.VITE_PUBLIC_URL + item?.programRoutePath, { replace: true });

        // alert('', '?');
    };

    return (
        <>
            {/* 임시 주석 help 랑 즐겨찾기 복구 예정 */}
            {/* {menuId !== HOME_MENU_ID && v?.c ? (
                <h2 className={styles[v?.eptz]}>
                    <button>Back</button>
                    {menuId && menuName ? (
                        <>
                            <div className={styles[v?.eptxz]}>
                                {menuNameList}
                                <span>{showMenuId && ` (${menuId})`}</span>
                            </div>
                            <div className={styles[v?.epiz]}>
                                {helpYn === 'Y' && (
                                    <span className={styles.help} onClick={openPopup}>
                                        도움말<em className={styles[v?.ett]}>도움말</em>
                                    </span>
                                )}
                                {helpYn === 'Y' && <span className={styles[v?.eptb]}></span>}
                                <span
                                    className={`${styles.favorite} ${
                                        getFavoriteMenuState(menuId) && styles.selected
                                    }`}
                                    onClick={() => {
                                        onSetFavorite(menuId);
                                    }}
                                >
                                    즐겨찾기
                                    <em className={styles[v?.ett]}>즐겨찾기</em>
                                </span>
                            </div>
                        </>
                    ) : null}
                </h2>
            ) : null}
            {children} */}
            {menuId !== HOME_MENU_ID ? (
                <div className={styles.breadcrumb} style={{display:'none'}}>
                    <button onClick={homeButtonHandle} className={styles.breadcrumbItem}>
                        <span>
                            <i translate="no">home</i>
                            <span>HOME</span>
                        </span>
                    </button>
                    {menuPath?.map((x, idx) => (
                        <React.Fragment key={idx}>
                            <span className={styles.breadcrumbSeparator}>›</span>
                            <span
                                className={`${styles.breadcrumbItem} ${
                                    x.menuId === selectedMenu?.menuId ? styles.active : ''
                                } ${!x.programRoutePath ? styles.none : ''}`}
                                onClick={() => x.programRoutePath && movePage(x)}
                            >
                                {x.menuName}
                            </span>
                        </React.Fragment>
                    ))}
                </div>
            ) : (
                <></>
            )}

            {children}
            <HelpPopup ref={refPopup} />
        </>
    );
};

PageContainer.propTypes = {
    children: PropTypes.node,
    menuName: PropTypes.string,
    menuId: PropTypes.string,
    menuNameList: PropTypes.string,
};
PageContainer.displayName = 'PageContainer';
export default PageContainer;
